/* eslint-disable no-console */
/* eslint-disable unicorn/no-console-spaces */
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { AchsJWT } from '@ui-core/interfaces/AchsJWTInterface';

/**
 * Set expiration token date.
 *
 * @param {string} authorization - Bearer token.
 * @param {boolean} getString - If you wan't the expiration token date.
 *
 * @returns {void | string} The expiration token date.
 */
export const setExpirationTokenDate = (
    authorization: string,
    getString = false
): void | string => {
    let tokenHeaderDecode = {} as AchsJWT;
    let tokenPayloadDecode = {} as AchsJWT;
    let tokenIsValid = false;
    let tokenString = '';
    try {
        tokenString = authorization.split(' ')[1];
        tokenHeaderDecode = jwtDecode(tokenString, { header: true });
        tokenPayloadDecode = jwtDecode(authorization);
        tokenIsValid = true;
    } catch (error: any) {
        console.log('Token decode error: ', error.message);
    }

    if (tokenIsValid) {
        const { iat } = tokenPayloadDecode;
        const { exp } = tokenHeaderDecode;
        const issuedAt = moment.unix(iat);
        const expirationTime = moment.unix(exp);

        const timer = expirationTime.diff(issuedAt, 'seconds');
        const expirationDate = moment().unix() + timer;

        if (!getString)
            localStorage.setItem('expirationTokenDate', `${expirationDate}`);
        else return `${expirationDate}`;
    }
};
